import { render } from "./NextStat.vue?vue&type=template&id=ee0680f6&scoped=true&ts=true"
import script from "./NextStat.vue?vue&type=script&lang=ts"
export * from "./NextStat.vue?vue&type=script&lang=ts"

import "./NextStat.vue?vue&type=style&index=0&id=ee0680f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee0680f6"]])

export default __exports__